/* Info component for the DeptsGeneral page */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";

const Info = () => {
  return (
    <div>
        <Row className='mb-3'>
            <Col className={`text-center px-3 py-1 ${styles.SubTitle6 }`} md={{span: 10, offset: 1 }}>
            <h5 className={`text-center ${styles.Red }`} >DEPARTMENT POSTS INFO</h5>  
            <hr className={`mt-2 mb-0`}/>
            <p>Use the Department Posts for collaboration and issues within <span className={`${styles.Red}`}>Departments</span> outside of 
                the Primary Scenes Workspace.
           </p>
           <hr className={`mt-2 mb-0`}/>
            </Col>
        </Row>
    </div>
  )
}

export default Info